var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdficon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 3.00098H12.8789C13.2766 3.00104 13.658 3.15902 13.9392 3.4402L20.5608 10.0618C20.8419 10.343 20.9999 10.7244 21 11.1221V20.251C21 20.8477 20.7629 21.42 20.341 21.842C19.919 22.2639 19.3467 22.501 18.75 22.501H9C8.40326 22.501 7.83097 22.2639 7.40901 21.842C6.98705 21.42 6.75 20.8477 6.75 20.251V14.251",
    stroke: "#00325C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.37451V8.99951C13.5 9.39733 13.658 9.77886 13.9393 10.0602C14.2206 10.3415 14.6022 10.4995 15 10.4995H20.625",
    stroke: "#00325C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75024V10.8752C7.50195 11.0235 7.47419 11.1707 7.41834 11.3081C7.3625 11.4454 7.2797 11.5702 7.17485 11.6751C7.06999 11.7799 6.94519 11.8627 6.80782 11.9186C6.67044 11.9744 6.52328 12.0022 6.375 12.0002C5.8125 12.0002 5.25 11.5737 5.25 10.8752V4.12524C5.25 2.69134 6.02672 1.50024 7.5 1.50024C8.97328 1.50024 9.75 2.66274 9.75 4.09618V10.6001C9.75 12.6157 8.44593 14.2502 6.375 14.2502C4.30406 14.2502 3 12.6162 3 10.6001V6.75024",
    stroke: "#00325C",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdficon);
export default __webpack_public_path__ + "static/media/pdficon.5ba3e01cd270594787fd40a18326cc34.svg";
export { ForwardRef as ReactComponent };